<template>
  <vue-nestable
    v-if="postsProp"
    v-model="nestablePosts"
    :max-depth="1"
    :hooks="{
      beforeMove: beforeMove,
    }"
  >
    <vue-nestable-handle
      slot-scope="{ item }"
      :item="item"
      class="flex w-full my-8 flex-wrap lg:flex-nowrap"
    >
      <div
        :style="{
          height: 'max-content',
        }"
        class="flex w-full lg:w-1/3 flex-shrink-0 mr-6 pointer-cursor"
      >
        <button
          v-if="config.posts.length > 1 && config.build"
          class="drag w-6 bg-truegray-100 flex-shrink-0 flex items-center justify-center border rounded pointer-events-none"
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 hover:text-primary transition-all duration-100"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <img
          class="w-full h-auto"
          :src="item.image_featured"
          alt="Featured image"
        />
      </div>
      <div class="w-full pl-4">
        <div class="flex flex-col space-y-2 py-2">
          <p class="newsletter-post-title">
            {{ item.title }}
          </p>
          <p class="newsletter-body-text">
            {{ item.description }}
          </p>
          <a
            :href="settings.host_domain + '/post/' + item.id"
            target="_blank"
            class="no-underline text-primary py-1 text-xs font-normal border border-primary w-24 rounded flex items-center justify-center"
          >
            Read more</a
          >
        </div>
        <!--
          <div class="group">
          <svg
          @click="
          attachDetachToPostList(item)
          "
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-300 hover:text-gray-500 cursor-pointer transition-all duration-100"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          >
          <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
          </svg>
          <div
          class="ml-2 text-xs absolute left-full top-0 w-24 z-50 border border-truegray-300 rounded py-2 px-4 opacity-0 transition-all duration-300 transform pointer-events-none group-hover:opacity-100 bg-white text-center"
          >
          Remove
          </div>
          </div> 
        -->
      </div>
    </vue-nestable-handle>
  </vue-nestable>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../../../../js/plugins/event-bus.js'
import { VueNestable, VueNestableHandle } from 'vue-nestable'

export default {
  components: {
    VueNestable,
    VueNestableHandle,
  },

  props: {
    config: { default: null },
  },

  data() {
    return {
      nestablePosts: [],
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),

    postsProp() {
      return this.config?.posts?.length > 0
    },
  },

  watch: {
    'config.posts': {
      handler: function (val) {
        this.$set(this, 'nestablePosts', val)
      },

      deep: true,
    },

    'nestablePosts': {
      handler: function (val) {
        // Remap the posts objects to ids to send to parent enroute to backend
        const postIds = val.map((post) => post.id)
        EventBus.$emit('newsletterPostOrderUpdated', postIds)
      },

      deep: true,
    },
  },

  async mounted() {
    if (this.config.posts) {
      this.$set(this, 'nestablePosts', this.config.posts)
    }
  },

  methods: {
    beforeMove() {
      return this.config.build
    },
  },
}
</script>

<style scoped>
.newsletter-preview * {
  font-family: 'Helvetica';
}

/* Tailwind not working on these column classes for some reason */
.newsletter-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}

/* Tailwind not working on these column classes for some reason */
.newsletter-grid .col-span-2 {
  grid-column: span 2 / span 2 !important;
}

.newsletter-title {
  font-size: 30px;
  font-weight: 600;
}

.newsletter-body-text {
  font-size: 12px;
  color: #656d78;
  margin: 0;
}

.newsletter-post-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.clamp-subject {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.seperator-right::after {
  content: '';
  position: absolute;
  right: -6px;
  top: 50%;
  height: 14px;
  width: 1px;
  transform: translateY(-50%);
  background: #e5e7eb;
}
</style>
